import { mutations } from "./mutations";
import { state } from "./state";
import { actions } from "./actions";

export const searches = {
  state,
  mutations,
  actions
};
